// Hợp đồng field `kind` trong marker `.claude/avatar.json` (card #254) — phần THUẦN.
//
// Tách khỏi `read-workspace-marker-kind.ts` (bên đó đọc file, import `node:fs`) để mặt tiền
// `@nalvietnam/avatar-cli/core` re-export được mà không kéo `node:*`. Extension cần đúng luật
// này: workspace DataHub mang pack sót lại mà CLI CỐ Ý không sync ⇒ extension so pack đó với
// stable sẽ mời "Cập nhật ngay" mãi, bấm cũng không lên (đo 2026-10-09, ~/AvatarDataHub).
//
// Fail-safe: JSON hỏng / không phải object / `kind` không phải chuỗi khác rỗng ⇒ "dev" — đúng
// hành vi trước khi có field này (workspace dev cũ không ghi `kind`).

export const DEV_WORKSPACE_KIND = "dev";

/** `raw` = nội dung `.claude/avatar.json`. Không bao giờ throw. */
export function parseWorkspaceMarkerKind(raw: string): string {
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return DEV_WORKSPACE_KIND;
  }
  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
    return DEV_WORKSPACE_KIND;
  }
  const kind = (parsed as Record<string, unknown>).kind;
  if (typeof kind !== "string" || kind.trim() === "") return DEV_WORKSPACE_KIND;
  return kind.trim();
}
